import React, { useState, useEffect, useContext } from 'react';
import {
  Tabs,
  Tab,
  List,
  ListItem,
  ListItemText,
  Divider,
  Typography,
  Box,
  Skeleton,
  Container,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControlLabel,
  Checkbox,
  Fab,
} from '@mui/material';
import { useMediaQuery } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { fetchProfileData, cancelBooking, fetchBookingsForDay } from './api';
import { useTheme } from '@mui/material/styles';
import BookingModal from './BookingModal';
import { AuthContext } from './AuthContext';
import { useDatePickerStyles } from './DatePickerStyles';
import { useHookState } from './NotificationApiHook';
import { PlaceContext } from '../contexts/PlaceContext';

import Pagination from '@mui/material/Pagination';

const Bookings = ({}) => {
  const [activeTab, setActiveTab] = useState(0);
  const [profileData, setProfileData] = useState(null);
  const [uniqueBookingDays, setUniqueBookingDays] = useState([]);
  const [bookingsForDay, setBookingsForDay] = useState([]);
  const [loadingBookings, setLoadingBookings] = useState(false);
  const theme = useTheme();
  const [selectedBlocks, setSelectedBlocks] = useState([]);
  const fabVisible = selectedBlocks.length > 0;
  const [currentTime, setCurrentTime] = useState(new Date());
  const [upcomingBookings, setUpcomingBookings] = useState([]);
  const [archiveBookings, setArchiveBookings] = useState([]);
  const [selectedBooking, setSelectedBooking] = useState({});
  const [isModalOpen, setModalOpen] = useState(false);
  const { isLoggedIn, token } = useContext(AuthContext);
  const [loggedIn, setLoggedIn] = useState(false);
  const [cancelBookingDialogOpen, setCancelBookingDialogOpen] = useState(false);
  const [bookingToCancel, setBookingToCancel] = useState(null);
  const [cancelForYear, setCancelForYear] = useState(false);
  const { styles } = useDatePickerStyles();
  const isAdmin = localStorage.getItem('role_id') === '1';
  const isMobile = useMediaQuery('(max-width:600px)');
  const { notificationState } = useHookState();
  const [expandedPanel, setExpandedPanel] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 7; // количество элементов на странице
  const [offset, setOffset] = useState(0);
  const [totalDays, setTotalDays] = useState(0);
  const { placeId } = useContext(PlaceContext);

  const handlePageChange = (event, page) => {
    setOffset(itemsPerPage * (page - 1));
    console.log('Page is', page);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        console.log('TOken', token);
        if (token) {
          const data = await fetchProfileData(token, notificationState, offset, placeId);
          setTotalDays(data.day_items);
          const currentDays = data.days;
          console.log('Set currentDays', currentDays);
          setUniqueBookingDays(currentDays);
          // if (currentDays.length > 0) {
          //   const selectedDay = currentDays[0].day;
          //   const bookings = await fetchBookingsForDay(token, selectedDay, notificationState);
          //   setBookingsForDay(bookings);
          // }
        } else {
          setUniqueBookingDays([]);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    console.log('FETCH DATA');
    fetchData();
  }, [offset, isLoggedIn, currentTime]);

  // useEffect(() => {
  //   setLoggedIn(isLoggedIn);
  //   const token = localStorage.getItem('token');

  //   const fetchData = async () => {
  //     try {
  //       if (token) {
  //         const data = await fetchProfileData(token, notificationState, 7);
  //         setUniqueBookingDays(data.days);
  //         console.log(data.days);

  //         if (data.days && data.days.length > 0) {
  //           const bookings = await fetchBookingsForDay(token, data.days[0].day, notificationState);
  //           setBookingsForDay(bookings);
  //         }
  //       } else {
  //         setUniqueBookingDays([]);
  //       }
  //     } catch (error) {
  //       console.error('Error fetching data:', error);
  //     }
  //   };

  //   fetchData();
  // }, [isLoggedIn, currentTime]);

  useEffect(() => {
    setLoggedIn(isLoggedIn);
    console.log('DAYS', uniqueBookingDays);
    if (token && uniqueBookingDays.length > 0) {
      fetchBookingsForDay(token, uniqueBookingDays[0].day, notificationState, placeId)
        .then((bookings) => {
          setBookingsForDay(bookings);
        })
        .catch((error) => {
          console.error('Error fetching books for day:', error);
        });
    }
  }, [uniqueBookingDays, currentTime]);

  // useEffect(() => {
  //   // Обновление текущего времени при переключении вкладок
  //   setCurrentTime(new Date());
  // }, [activeTab]);

  useEffect(() => {
    if (profileData?.books) {
      const upcomingBookings = profileData.books.filter((booking) => {
        const bookingTime = new Date(
          `${booking.day.replace(/"/g, '')}T${booking.end_time
            .replace(/"/g, '')
            .replace(/"/g, '')}`,
        );
        return bookingTime >= currentTime;
      });

      const archiveBookings = profileData.books.filter((booking) => {
        const bookingTime = new Date(
          `${booking.day.replace(/"/g, '')}T${booking.end_time
            .replace(/"/g, '')
            .replace(/"/g, '')}`,
        );
        return bookingTime < currentTime;
      });

      setUpcomingBookings(upcomingBookings);
      setArchiveBookings(archiveBookings);
    } else {
      // Если нет данных о бронированиях, считаем upcomingBookings и archiveBookings пустыми массивами
      setUpcomingBookings([]);
      setArchiveBookings([]);
    }
  }, [profileData, currentTime]);

  const getTime = (day, time) => {
    const date = new Date(`${day}T${time}`);
    return date.toLocaleString('ru-RU', { hour: '2-digit', minute: '2-digit' });
  };

  const getDayMonth = (day) => {
    var options = {
      month: 'numeric',
      day: 'numeric',
      year: 'numeric',
    };

    const date = new Date(`${day}`);
    return date.toLocaleString('ru-RU', options);
  };

  const getWeekDay = (day) => {
    var options = {
      weekday: 'short',
    };

    const date = new Date(`${day}`);
    return date.toLocaleString('ru-RU', options);
  };
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    setCurrentTime(new Date());
  };

  if (!uniqueBookingDays && loggedIn) {
    return (
      <Container sx={{ marginTop: '100px' }}>
        <Skeleton height={60} />
        <Skeleton height={60} />
        <Skeleton height={60} />
        <Skeleton height={60} />
        <Skeleton height={60} />
      </Container>
    );
  }

  if (!loggedIn) {
    return (
      <Container sx={{ marginTop: '100px' }}>
        <Typography
          variant='h6'
          sx={{ textAlign: 'center', marginBottom: '50px' }}
        >
          {' '}
          Брони недоступны <br /> Войдите в систему{' '}
        </Typography>
        <Skeleton height={60} />
        <Skeleton height={60} />
        <Skeleton height={60} />
        <Skeleton height={60} />
        <Skeleton height={60} />
        <Skeleton height={60} />
        <Skeleton height={60} />
      </Container>
    );
  }

  const handleBookingClick = (booking) => {
    setSelectedBooking(booking);
    setModalOpen(true);
  };

  const handleConfirmCancelBooking = async () => {
    const bookingsToCancel = selectedBlocks.map((block) => ({
      id: block.id,
      time_range_id: block.time_range_id,
      table_number: block.table_number,
      place_id: block.place_id,
      amount: block.amount,
    }));
    try {
      await cancelBooking(token, bookingsToCancel, cancelForYear, notificationState);
      setSelectedBlocks([]);
      setCancelForYear(false);
      setCancelBookingDialogOpen(false);
      setCurrentTime(new Date());
    } catch (error) {
      console.error(error);
    }
  };

  const handleCancelBooking = (booking) => {
    setBookingToCancel(booking);
    setCancelBookingDialogOpen(true);
  };

  const handleCancelDialog = () => {
    // Закройте диалоговое окно при отмене
    setCancelBookingDialogOpen(false);
  };

  // Функция для переключения выбранного временного блока
  const toggleTimeBlock = (block) => {
    setSelectedBlocks((prevBlocks) => {
      const blockIndex = prevBlocks.findIndex((selectedBlock) => selectedBlock.id === block.id);
      if (blockIndex !== -1) {
        // Если блок уже выбран, снимаем его выбор
        return prevBlocks.filter((selectedBlock) => selectedBlock.id !== block.id);
      } else {
        // Если блок еще не выбран, добавляем его в список выбранных
        return [...prevBlocks, block];
      }
    });
  };

  const handleAccordionChange = async (index) => {
    setExpandedPanel(index === expandedPanel ? -1 : index);
    const selectedDay = uniqueBookingDays[index];
    console.log(selectedDay.day);
    if (selectedDay) {
      setLoadingBookings(true);

      try {
        const bookings = await fetchBookingsForDay(
          token,
          selectedDay.day,
          notificationState,
          placeId,
        );
        setBookingsForDay(bookings);
      } catch (error) {
        console.error('Error fetching bookings for day:', error);
      } finally {
        setLoadingBookings(false);
      }
    }
  };
  return (
    <div>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
        >
          <Tab label='Мои Брони' />
          <Tab label='Архив' />
        </Tabs>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Pagination
          count={Math.ceil(totalDays / itemsPerPage)}
          page={Math.ceil(offset / itemsPerPage) + 1}
          onChange={handlePageChange}
          color='primary'
          sx={{
            marginTop: 2,
            visibility: Math.ceil(totalDays / itemsPerPage) > 1 ? 'visible' : 'hidden',
          }}
        />
      </Box>
      {activeTab === 0 ? (
        <Box
          sx={{
            maxHeight: fabVisible ? 'calc(100svh - 350px)' : 'calc(100svh - 300px)',
            minHeight: fabVisible ? 'calc(100svh - 350px)' : 'calc(100svh - 300px)',
            overflow: 'auto',
            ...styles.scrollbar,
          }}
        >
          <List
            sx={{
              maxHeight: fabVisible ? 'calc(100vh - 275px)' : 'calc(100vh - 190px)',
              ...styles.scrollbar,
            }}
          >
            {uniqueBookingDays.map((day, index) => (
              <Accordion
                key={index}
                expanded={expandedPanel === index}
                onChange={() => handleAccordionChange(index)}
                sx={{
                  '&.MuiAccordion-root': {
                    boxShadow: 'none',
                  },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`panel-${index}-content`}
                  id={`panel-${index}-header`}
                >
                  <Typography sx={{ textTransform: 'capitalize' }}>
                    {`${getDayMonth(day.day.replace(/"/g, ''))}  ${getWeekDay(
                      day.day.replace(/"/g, ''),
                    )}`}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {loadingBookings ? (
                    <LoadingButton
                      color='primary'
                      sx={{
                        backgroundColor: theme.palette.primary.main,
                        color: theme.palette.primary.contrastText,
                        borderRadius: '0px',
                        paddingTop: 4,
                        paddingBottom: 3,
                        width: '100%',
                        '&.Mui-disabled': {
                          backgroundColor: '#fff',
                          color: theme.palette.primary.contrastText,
                        },
                        '&:hover': {
                          backgroundColor: '#8e80d7',
                        },
                      }}
                      disabled
                      variant='contained'
                      loading={loadingBookings}
                    ></LoadingButton>
                  ) : (
                    <List key={bookingsForDay.length}>
                      {bookingsForDay.map((booking) => (
                        <React.Fragment key={booking.id}>
                          <ListItem
                            key={booking.id}
                            button
                            onClick={() => toggleTimeBlock(booking)}
                            selected={selectedBlocks.some(
                              (selectedBlock) => selectedBlock.id === booking.id,
                            )}
                            sx={{
                              color: '#000000b0',
                              '&.Mui-selected': {
                                backgroundColor: theme.palette.primary.main,
                                color: theme.palette.primary.contrastText,
                                '& .MuiListItemText-secondary': {
                                  color: theme.palette.primary.contrastText,
                                },
                              },
                              '&:hover': {
                                backgroundColor: '#5f51a666',
                              },
                              '&.MuiListItem-root': {
                                justifyContent: 'space-between',
                              },
                              '&.Mui-selected:hover': {
                                backgroundColor: theme.palette.primary.light,
                              },
                            }}
                          >
                            <Typography
                              sx={{
                                display: 'flex',
                              }}
                            >
                              {`${getTime(
                                booking.day.replace(/"/g, ''),
                                booking.start_time.replace(/"/g, ''),
                              )} - ${getTime(
                                booking.day.replace(/"/g, ''),
                                booking.end_time.replace(/"/g, ''),
                              )}`}
                            </Typography>
                            <Button
                              sx={{
                                display: 'flex',
                              }}
                              color='primary'
                              onClick={(event) => {
                                event.stopPropagation();
                                handleBookingClick(booking);
                              }}
                            >
                              Войти в зал
                            </Button>
                            <Typography
                              sx={{
                                display: 'flex',
                              }}
                            >
                              Стол {booking.table_number}
                            </Typography>
                          </ListItem>
                          <Divider />
                        </React.Fragment>
                      ))}
                    </List>
                  )}
                </AccordionDetails>
              </Accordion>
            ))}
          </List>
        </Box>
      ) : (
        <div>
          {archiveBookings.length > 0 ? (
            archiveBookings.map((booking) => (
              <div key={booking.id}>
                <ListItem>
                  <ListItemText
                    primary={booking.day.replace(/"/g, '')}
                    secondary={`Время: ${getTime(
                      booking.day.replace(/"/g, ''),
                      booking.start_time.replace(/"/g, ''),
                    )} - ${getTime(
                      booking.day.replace(/"/g, ''),
                      booking.end_time.replace(/"/g, ''),
                    )}`}
                  />
                  Стол {booking.table_number}
                </ListItem>
                <Divider />
              </div>
            ))
          ) : (
            <Typography
              variant='body1'
              sx={{ textAlign: 'center', marginTop: 10 }}
            >
              Нет архивных бронирований
            </Typography>
          )}
        </div>
      )}

      <Dialog
        open={cancelBookingDialogOpen}
        onClose={handleCancelDialog}
      >
        <DialogTitle
          sx={{
            textAlign: 'center',
          }}
        >
          Подтверждение отмены брони
        </DialogTitle>
        <DialogContent>
          {isAdmin && (
            <FormControlLabel
              control={
                <Checkbox
                  checked={cancelForYear}
                  onChange={() => setCancelForYear(!cancelForYear)}
                />
              }
              label={`Отменить все брони на ${
                selectedBlocks.length === 1
                  ? 'это выбранное время?'
                  : 'эти выбранные блоки времени?'
              }`}
            />
          )}
          <Typography
            sx={{
              textAlign: 'center',
              padding: '10px',
            }}
          >
            {`Вы уверены, что хотите отменить ${selectedBlocks.length === 1 ? 'бронь' : 'брони'}?`}
          </Typography>
          {selectedBlocks.map((block) => (
            <React.Fragment key={block.id}>
              <Typography
                sx={{
                  display: 'flex',
                  float: 'left',
                  padding: '5px',
                }}
              >
                {`${getDayMonth(block.day.replace(/"/g, ''))} `}
                {`${getTime(
                  block.day.replace(/"/g, ''),
                  block.start_time.replace(/"/g, ''),
                )} - ${getTime(block.day.replace(/"/g, ''), block.end_time.replace(/"/g, ''))}`}
              </Typography>
              <Typography
                sx={{
                  padding: '5px',
                  display: 'flex',
                  justifyContent: 'flex-end',
                }}
              >
                {`Cтол ${block.table_number}`}
              </Typography>
            </React.Fragment>
          ))}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCancelDialog}
            color='primary'
          >
            Отмена
          </Button>
          <Button
            onClick={handleConfirmCancelBooking}
            color='primary'
          >
            Подтвердить отмену
          </Button>
        </DialogActions>
      </Dialog>
      <BookingModal
        open={isModalOpen}
        onClose={() => setModalOpen(false)}
        booking={selectedBooking}
        token={token}
      />
      <Fab
        color='primary'
        onClick={handleCancelBooking}
        disabled={!isLoggedIn}
        sx={{
          backgroundColor: theme.palette.primary.main,
          position: 'sticky',
          bottom: '58px',
          marginLeft: isMobile ? '0' : 'calc(50% - 275px)',
          display: fabVisible ? 'block' : 'none',
          width: '100%',
          maxWidth: '600px',
          height: '80px',
          lineHeight: '30px',
          padding: '15px',
          zIndex: '100',
          borderRadius: '0',
          '&.Mui-disabled': {
            backgroundColor: '#4b4b4b',
            color: theme.palette.primary.contrastText,
          },
        }}
      >
        {isLoggedIn ? <Box>Отменить бронь</Box> : <Box>Войдите, чтобы увидеть брони</Box>}
      </Fab>
    </div>
  );
};

export default Bookings;
